import { ReactNode } from 'react';
import { IconName } from '@optimus-web/icons';
import { IconVariant } from '../Icon';
import { Stack } from '../Stack';
import { IconListItem, IconListItemDescription, IconListItemIcon, IconListItemLabel } from './style';

export interface IconListItemProps {
    key: string;
    icon: IconName;
    variant?: IconVariant;
    label: ReactNode;
    description?: ReactNode;
}

export interface IconListProps {
    items: IconListItemProps[];
    small?: boolean;
    compact?: boolean;
}

export const IconList = ({ items, small = false, compact = false, ...other }: IconListProps) => (
    <Stack as="ul" vertical spacing={compact ? '100' : '200'} {...other}>
        {items.map(({ key, icon, variant, label, description }) => (
            <IconListItem key={key}>
                <IconListItemIcon value={icon} variant={variant} />
                <div>
                    <IconListItemLabel small={small}>{label}</IconListItemLabel>
                    <IconListItemDescription small={small}>{description}</IconListItemDescription>
                </div>
            </IconListItem>
        ))}
    </Stack>
);
